import MyButton from 'components/MyButton/MyButton';
import React from 'react';
import coalesceClassNames from 'utils/coalesceClassNames';
import Dialog from './Dialog';

export type AlertProps = {
    acceptLabel?: string;
    className?: string;
    title?: string | React.ReactFragment;
    message?: string | React.ReactFragment;
    close?: () => void;
};

export default function Alert({
    acceptLabel = 'OK',
    className,
    close = () => {},
    title,
    message,
}: AlertProps) {
    return (
        <Dialog
            className={coalesceClassNames('DialogManager__dialog--alert', className)}
            title={title}
            message={message}
            close={close}
            buttons={
                <MyButton
                    buttonType="Primary"
                    onClick={close}
                >
                    {acceptLabel}
                </MyButton>
            }
        />
    );
}
